module.exports = __webpack_public_path__ + "img/accept_icon.f968a341.svg";